import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { assetUrl } from 'src/app/globals/globals';
import { PersonI } from 'src/app/interfaces/transfer-points/transferPoints.interface';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { TransferService } from 'src/app/services/api/transfer/transfer.service';


enum Step {
  GENERATE_CODE = 1,
  TRANSFER_POINT = 2
}

@Component({
  selector: 'app-conversor',
  templateUrl: './transferPoints.component.html',
  styleUrls: ['./transferPoints.component.scss'],
})
export class TransferComponent implements OnInit {
  assetUrl = assetUrl;

  programs: any[];
  benefits: any = [];
  destinatario: string = '';
  destinatarioNoExiste: boolean = false;
  transferForm: FormGroup;
  form: FormGroup;
  currentUser: any;
  guestUser: boolean = true;
  userToken?: string | null;
  userBalance: number = 0;
  transferSuccess: boolean = false;
  isBlocked: boolean = false;
  transferError: boolean = false;
  showError: string = '';
  showTransferModal: boolean = false;
  transferButtonDisabled: boolean = false;
  selfTransference: boolean;
  Code: FormGroup;
  isLoggedIn: boolean = false;
  showRevalidate: boolean = false;
  isErrorConfirmed: boolean = false;
  loading: boolean = false;
  stepValidaion: Step = 1
  insufficientPoints: boolean = false;
  showConfirmationPopup: boolean = false;
  confirmationCode: string[] = ['', '', '', ''];
  countdown: number = 120;
  timerInterval: any;
  validationForm: FormGroup;
  inputControls: string[] = ['input1', 'input2', 'input3', 'input4'];



  constructor(
    private _benefitService: BenefitsService,
    private _transferService: TransferService,
    public authService: AuthService,
    private formBuilder: FormBuilder,
  ) {
    this.transferForm = this.formBuilder.group({
      inputValue: new FormControl('', [Validators.required]),
      pointsValue: new FormControl('', [Validators.required, Validators.min(0)]),
    });

    this.transferForm.valueChanges.subscribe(() => {
      this.checkFormValidity();
    });

    this.statusLogin();
  }

  ngOnInit(): void {
    this.getBenefits();
    this.handleUser();
    this.showTransferModal = false;
    this.checkFormValidity();
    this.startCountdown();
    this.initForm();
  }

  initForm(): void {
    this.validationForm = this.formBuilder.group({
      input1: ['', Validators.required],
      input2: ['', Validators.required],
      input3: ['', Validators.required],
      input4: ['', Validators.required]
    });
  }

  onKeyUp(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Avanzar al siguiente input si se ingresó un dígito
    if (value.length === 1 && index < this.inputControls.length - 1) {
      const nextInput = document.querySelector(
        `input[formControlName="${this.inputControls[index + 1]}"]`
      ) as HTMLInputElement;
      nextInput?.focus();
    }

    // Retroceder al input anterior con Backspace
    if (event.key === 'Backspace' && value.length === 0 && index > 0) {
      const prevInput = document.querySelector(
        `input[formControlName="${this.inputControls[index - 1]}"]`
      ) as HTMLInputElement;
      prevInput?.focus();
    }

    // Asegurar que solo se ingresen números
    if (!/^\d$/.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
      input.value = '';
    }
  }


  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text').trim();

    if (pastedText.length === 4 && /^\d+$/.test(pastedText)) {
      for (let i = 0; i < 4; i++) {
        this.validationForm.get(this.inputControls[i])?.setValue(pastedText[i]);
      }
    }
  }

  getValidationCode(): number {
    const code = Object.values(this.validationForm.value).join('')
    return Number(code)
  }

  get codeControls() {
    return (this.form.get('code') as FormArray).controls;
  }


  resendCode() {
    this.countdown = 120;
    clearInterval(this.timerInterval);
    this.startCountdown();
  }

  restrictToNumbers(event: KeyboardEvent, index: number) {
    const isNumber = /^\d$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
      return;
    }
  }

  startCountdown() {
    this.timerInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }


  checkFormValidity(): void {
    const inputValueControl = this.transferForm.get('inputValue');
    const pointsValueControl = this.transferForm.get('pointsValue');

    const formValid = this.transferForm.valid && inputValueControl?.value;

    if (formValid) {
      if (pointsValueControl?.pending || this.insufficientPoints) {
        this.transferButtonDisabled = true;
      } else {
        this.transferButtonDisabled = false;
      }
    } else {
      this.transferButtonDisabled = true;
    }
  }

  async statusLogin(): Promise<void> {
    try {
      this.isLoggedIn = await this.authService.IsLoggedIn();
    } catch (error) {
      console.error(error);
    }
  }

  getBenefits() {
    this._benefitService.get().subscribe((benefits: any) => {
      this.benefits = benefits;
    });
  }

  closeModal(confirmTransfer: boolean = false) {
    this.validationForm.reset();
    if (confirmTransfer) {
      this.showTransferModal = true;
    } else {
      if (this.transferSuccess) {
        window.location.reload();
      } else {
        this.showTransferModal = false;
        this.transferSuccess = false;
        this.transferError = false;
        this.showConfirmationPopup = false;
      }
    }
  }

  async handleUser() {
    try {
      this.userToken = await this.authService.getAccessToken();
      this.currentUser = await this.authService.getCurrentUser();

      this.guestUser = !(this.userToken != null && this.userToken.length > 0);

      if (!this.guestUser) {
        const pointsResponse: any = await this.authService
          .getPersonPoints()
          .toPromise();
        this.userBalance = pointsResponse;
      }
    } catch (error) {
      console.error('Error al obtener los puntos del usuario:', error);
    }
  }


  async transferPoints(dni: string, quantityPoints: number) {
    this.loading = true;
    this.transferButtonDisabled = true;

    try {
        await this._transferService.transferPoints(dni, quantityPoints).toPromise();

        this.transferSuccess = true;
        this.showConfirmationPopup = true;
        this.transferError = false;
        this.showTransferModal = true;
        this.authService.getPerson().subscribe(data => {
            this.authService.refreshUser(data);
        });

    } catch (error: any) {
        console.error('Error en la transferencia de puntos:', error);

        if (error.status === 401) {
            this.stepValidaion = Step.GENERATE_CODE;
            await this.generateCodeForm();
            return
        }

        this.transferSuccess = false;
        this.transferError = true;
        this.showTransferModal = true;
        this.loading = false;
        this.showConfirmationPopup = true;
    } finally {
        this.loading = false;
        this.transferButtonDisabled = false;
    }
}


  handleSearch() {
    this.transferSuccess = false;
    this.transferError = false;

    const inputValueControl = this.transferForm.get('inputValue');
    const pointsValueControl = this.transferForm.get('pointsValue');

    if (inputValueControl && inputValueControl.value) {
      const condition = inputValueControl.value;

      this._transferService.getPersonByCondition(condition).subscribe(
        (response: PersonI) => {
          if (response && response.firstName && response.lastName) {
            this.destinatario = response.firstName + ' ' + response.lastName;
            this.destinatarioNoExiste = false;
            this.selfTransference = this.isSelfTransfer(condition);
            if (this.selfTransference) {
              pointsValueControl?.disable();
              this.transferButtonDisabled = true;
            } else {
              pointsValueControl?.enable();
            }
          } else {
            this.destinatario = '';
            this.destinatarioNoExiste = true;
            this.transferButtonDisabled = true;
          }
        },
        (error) => {
          this.destinatarioNoExiste = true;
          this.destinatario = '';
          this.transferButtonDisabled = true;

          if (error.status === 404) {
            console.log('El destinatario no está en el programa Shell Box');
          }
        }
      );
    } else {
      this.destinatario = '';
      this.transferButtonDisabled = true;
      console.error('El campo está vacío o es nulo.');
    }
  }

  async handleValue(): Promise<void> {
    try {
      const pointsValueControl = this.transferForm.get('pointsValue');

      if (pointsValueControl) {
        const quantityPoints = pointsValueControl.value;

        if (!this.guestUser) {
          const pointsResponse: number | undefined = await this.authService
            .getPersonPoints()
            .toPromise();
          if (pointsResponse !== undefined) {
            let availableBalance: number;

            const userData = localStorage.getItem('user');
            if (userData) {
              const user = JSON.parse(userData);
              availableBalance = user.context.activities[0].personStatus.accountBalance;
            } else {
              console.error('UserData is not available.');
              return;
            }

            this.insufficientPoints = quantityPoints > pointsResponse || quantityPoints > availableBalance;
            this.transferButtonDisabled = this.insufficientPoints;
          } else {
            console.error('El valor de los puntos no pudo ser obtenido.');
            this.insufficientPoints = false
          }
        }
      }
    } catch (error) {
      console.error('Error al manejar el valor de los puntos:', error);
    }
  }



  async generateCodeForm() {
    try {
      this.showRevalidate = false;
      this.showError = '';
      this.isErrorConfirmed = false
  
      const validateCode = await this._transferService.generateCode().subscribe({
        next: (res) => {
          this.stepValidaion = Step.TRANSFER_POINT;
          this.validationForm.reset();
          this.showError = '';
          this.showRevalidate = false;
          this.resendCode()
        },
        error: (error) => {
          console.error('Error generando codigo:', error);
          this.showRevalidate = error.error.status === 1;
          this.isErrorConfirmed = true
          this.showError = error.error.status === 1
            ? 'Ya has generado el código. Usélo antes de generarlo nuevamente'
            : 'Ocurrió un error al generar el código.';
        }
      });
  
      if (!validateCode) {
        return;
      }
  
      const inputValueControl = this.transferForm.get('inputValue');
      const pointsValueControl = this.transferForm.get('pointsValue');
  
      if (inputValueControl && inputValueControl.value && pointsValueControl && pointsValueControl.value) {
        const inputValue = inputValueControl.value;
  
        this.transferSuccess = false;
        this.transferError = false;
        this.selfTransference = false;
  
        if (this.isSelfTransfer(inputValue)) {
          this.transferError = true;
          this.selfTransference = true;
          this.showTransferModal = false;
          console.error('No puedes transferir a tu propia cuenta de Shell Box.');
        } else {
          this.showConfirmationPopup = true;
          this.showTransferModal = true;
        }
      } else {
        this.transferError = true;
        this.showTransferModal = true;
        console.error('El campo está vacío o es nulo.');
      }
    } catch (error) {
      console.error(error);
    }
  }

  async sendTransfer() {

    const inputValueControl = this.transferForm.get('inputValue');
    const pointsValueControl = this.transferForm.get('pointsValue');

    if (inputValueControl && pointsValueControl) {
      const inputValue = inputValueControl.value;
      const quantityPoints = pointsValueControl.value;

      this.transferPoints(inputValue, quantityPoints);
    }
  }


  async handleTransfer() {

    if (this._transferService.isBanActive()) {
      this.closeModal(true);
      this.isBlocked = true;
    } else if (!this._transferService.isBanActive()){
      if (this._transferService.isValidateCodeStillValid()) {
        this.sendTransfer();
      } else {
        this.stepValidaion = Step.GENERATE_CODE;
        await this.generateCodeForm();
  
      }
    } 


  }

  get isConfirmationCodeComplete(): boolean {
    return this.confirmationCode.every((code) => code.length === 1);
  }

  autoFocusNext(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value.length === 1 && index < 3) {
      const nextInput = input.parentElement?.querySelectorAll('input')[index + 1];
      (nextInput as HTMLInputElement)?.focus();
    }
  }

  confirmCode() {
    this.loading = true;
    const body = {
      code: this.getValidationCode()
    }

    this._transferService.validateCode(body).subscribe({
      next: () => {
        this.closeModal(false);
        this.stepValidaion = Step.TRANSFER_POINT
        this.loading = false;

      },
      error: (error) => {
        this.loading = false;
        if (error.error.validationAttempts === 5) {
          this.isBlocked = true;
          const now = new Date();
          const banUntil = new Date(now.getTime() + 24 * 60 * 60 * 1000);

          const stored = localStorage.getItem('validateCode');
          let data;

          if (stored) {
            try {
              data = JSON.parse(stored);
            } catch {
              data = {};
            }
          } else {
            data = {};
          }

          data.bandEnd = banUntil.toISOString();
          localStorage.setItem('validateCode', JSON.stringify(data));
        }
        console.error('Error generando codigo:', error);
        this.showError = 'Ocurrió un error al validar el código.';
      }
    });

  }

  cancelTransfer() {
    this.closeModal(false);
  }

  isSelfTransfer(inputValue: string): boolean {
    if (
      this.currentUser &&
      this.currentUser.person &&
      this.currentUser.person.profile
    ) {
      const userDocument = this.currentUser.person.profile.document;
      const userDni = userDocument ? userDocument.number : null;
      const userEmail = this.currentUser.person.profile.email;

      return inputValue === userDni || inputValue === userEmail;
    }

    return false;
  }
}
